import { Fragment, memo, useMemo } from "react"
import { Dialog, Transition } from "@headlessui/react"
import { SidePanelProps } from "../../../types"
import Actions from "./actions"
import Header from "./header"
import PanelWrapper from "./panel-wrapper"

const SidePanel = ({
  title,
  subTitle,
  isSubmitting = false,
  open,
  onClose,
  size = "4xl", // TODO: support dynamic size
  children,
  actions,
  hasTabs,
  isBack,
  titleClassName
}: SidePanelProps) => {
  const actionsNode = useMemo(() => {
    return actions?.length ? (
      <Actions isSubmitting={isSubmitting} actions={actions} />
    ) : null
  }, [actions, isSubmitting])

  return (
    <Transition.Root show={open} as={Fragment} appear>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <PanelWrapper
          actions={actionsNode}
          open={open}
          header={
            <Header
              title={title}
              subTitle={subTitle}
              onClose={onClose}
              hasTabs={hasTabs}
              isBack={isBack}
              titleClassName={titleClassName}
            />
          }
        >
          {children}
        </PanelWrapper>
      </Dialog>
    </Transition.Root>
  )
}

export default memo(SidePanel)
